import polyfills from './polyfills';
import detectTouch from './detectTouch';
import resourcesSlider from './resourcesSlider';
import customSelects from './customSelects';
import serviceFiltering from './servicesFiltering';
import scrollButtons from './scrollButtons';
import sidebar from './sidebar';
import datepicker from './datepicker';
import contactFormSuccess from './contactFormSuccess';
import searchForm from './searchForm';
import faqAccordions from './faqAccordions';
import burgerMenu from './burgerMenu';
import mobileCallback from './mobileCallbackForm';
import sameCategorySelect from './sameCategorySelect';
import contactsMap from './contactsMap';
import viewportHeight from './viewportHeight';
import StickyHeader from './stickyHeader';

document.addEventListener('DOMContentLoaded', function() {
    polyfills();
    detectTouch();
    resourcesSlider();
//    customSelects();
    serviceFiltering();
    scrollButtons();
    sidebar();
    datepicker();
    contactFormSuccess();
    searchForm();
    faqAccordions();
    burgerMenu();
    mobileCallback();
    sameCategorySelect();
    contactsMap();
    viewportHeight();
    StickyHeader();
});

window.addEventListener('load', function() {
    document.body.classList.add('loaded');
    setTimeout(() => document.body.classList.add('animatable'), 300)
})
